import { useCallback, useState } from 'react';
import { Bookmark } from 'react-bootstrap-icons';

import CoursesList, { OrderParams } from '@/components/shared/CoursesList';
import EmptyState from '@/components/shared/EmptyState';
import Wrapper from '@/components/shared/Wrapper';
import { isSubdomain } from '@/helpers/domian';
import { IPaginationParams } from '@/interfaces/pagination';
import { coursesApi } from '@/services/course';
import { useGetPackagesQuery } from '@/services/package';
import { shelvesApi } from '@/services/shelves';
import styled from '@/styled';

import Courses from './Courses';
import Packages from './Package';
import Shelves from './Shelves';

const MyCourses = () => {
  const [currentFilter, setCurrentFilter] = useState(0);
  const isPortal = isSubdomain();

  const [refetch, { isFetching, data: courses }] = coursesApi.endpoints.getCourses.useLazyQuery();
  const { data: packages } = useGetPackagesQuery({ size: 20, page: 1 });
  const [, { data: shelves }] = shelvesApi.endpoints.getShelf.useLazyQuery({});

  const onChoseFilter = useCallback(
    (order: OrderParams) => {
      setCurrentFilter(1);
      refetch({ ...order, page: 1, size: 100, hasParams: !!order });
    },
    [refetch]
  );

  const onReachedEnd = useCallback(
    (params: IPaginationParams) => {
      refetch({
        ...params
      });
    },
    [refetch]
  );

  const onComponentLoad = useCallback(() => {
    refetch({ page: 1, size: 20 });
  }, [refetch]);

  if (courses?.total_rows === 0 && (shelves?.total_rows === 0 || !shelves) && packages?.total_rows === 0) {
    return (
      <Wrapper>
        <EmptyState
          icon={<Bookmark size={48} />}
          title='Seus cursos aparecerão aqui...'
          description='Aqui você poderá acessar com facilidade todos seus cursos'
        />
      </Wrapper>
    );
  }

  return (
    <CoursesList
      title='Meus Cursos'
      queryProps={{ data: courses, isFetching }}
      onChoseFilter={onChoseFilter}
      onComponentLoad={onComponentLoad}
      onReachPageEnd={onReachedEnd}
    >
      {currentFilter === 0 && packages?.total_rows > 0 && (
        <>
          <Packages />
        </>
      )}
      {isPortal && currentFilter === 0 && (
        <>
          <Shelves />
        </>
      )}
      <Courses />
    </CoursesList>
  );
};

export default styled(MyCourses)`
  .ant-select {
    min-width: 150px;
  }

  .courses-title {
    margin-top: 36px;
    font-weight: 500;
  }
`;
